export default function CustomerHistoryCard({ customerHistory, onViewBookings, priority = false }) {
  if (!customerHistory) return null;

  const wrapperClass = priority
    ? "border-2 border-purple-200 rounded-2xl overflow-hidden bg-white"
    : "border rounded-2xl overflow-hidden bg-white";
  const headerClass = priority
    ? "bg-purple-50 px-4 py-3 text-sm font-semibold border-b flex items-center justify-between"
    : "bg-gray-50 px-4 py-3 text-sm font-semibold border-b flex items-center justify-between";
  const headerLabel = priority ? "Customer History (Priority Review)" : "Customer History";

  return (
    <div className={wrapperClass}>
      <div className={headerClass}>
        <span>{headerLabel}</span>
        {customerHistory.is_red_flag && (
          <span className="inline-flex items-center gap-1 rounded-full bg-red-100 text-red-700 px-2 py-0.5 text-xs font-semibold">
            🚩 Red Flag
          </span>
        )}
      </div>
      <div className="p-4 space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div className="rounded-xl bg-gray-50 border p-3">
            <div className="text-xs text-gray-500 font-semibold uppercase tracking-wide">Total Bookings</div>
            <div className="mt-1 text-xl font-bold text-gray-800">{customerHistory.total_bookings}</div>
          </div>
          <div className="rounded-xl bg-gray-50 border p-3">
            <div className="text-xs text-gray-500 font-semibold uppercase tracking-wide">Cancellations</div>
            <div className="mt-1 text-xl font-bold text-gray-800">{customerHistory.cancellation_requests}</div>
          </div>
          <div className="rounded-xl bg-gray-50 border p-3">
            <div className="text-xs text-gray-500 font-semibold uppercase tracking-wide">Reschedules</div>
            <div className="mt-1 text-xl font-bold text-gray-800">{customerHistory.reschedule_requests}</div>
          </div>
          <div className="rounded-xl bg-gray-50 border p-3">
            <div className="text-xs text-gray-500 font-semibold uppercase tracking-wide">Account Age</div>
            <div className="mt-1 text-xl font-bold text-gray-800">{customerHistory.account_age_label}</div>
            {(customerHistory.account_age_label.includes("year") ||
              customerHistory.account_age_label.includes("month")) && (
              <div className="text-xs text-gray-500 mt-0.5">
                {customerHistory.account_age_days} days total
              </div>
            )}
          </div>
        </div>

        {customerHistory.user_id && onViewBookings && (
          <button
            type="button"
            onClick={onViewBookings}
            className="w-full text-sm font-semibold text-blue-600 hover:text-blue-800 hover:underline text-left flex items-center gap-1"
          >
            → View all customer bookings ({customerHistory.total_bookings})
          </button>
        )}

        {customerHistory.is_red_flag && (
          <div className="rounded-xl border border-red-200 bg-red-50 p-3 text-sm text-red-700">
            <div className="font-semibold mb-1 flex items-center gap-1">
              🚩 Red Flag: High change request rate
            </div>
            <div className="text-xs leading-relaxed">
              This customer has a cancellation and rescheduling ratio above 35% across booking
              history. Please review the booking and request history before proceeding with
              exceptions, refunds, or manual changes.
            </div>
            <div className="mt-2 text-xs font-semibold">
              Change Request Ratio: {(customerHistory.change_request_ratio * 100).toFixed(0)}%
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
